"use strict";

require("core-js/modules/es.reflect.construct.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require("core-js/modules/es.function.bind.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.replace.js");
require("core-js/modules/es.string.trim.js");
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _formElements = require("@evidation/form-elements");
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _LanguageContext = require("../contexts/LanguageContext");
var _horizontalLabel = _interopRequireDefault(require("./labels/horizontalLabel"));
var _utils = require("./utils");
var _constants = require("../constants");
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var List = _styledComponents["default"].ul.withConfig({
  displayName: "insuranceProviderId__List"
})(["padding:0 0 8px 0;margin:0;list-style:none !important;li{margin-bottom:8px;}"]);
var InputRadio = _styledComponents["default"].input.withConfig({
  displayName: "insuranceProviderId__InputRadio"
})(["margin:4px 8px 0 0;minwidth:12px;maxwidth:15px;"]);
var ContainerLabel = _styledComponents["default"].label.withConfig({
  displayName: "insuranceProviderId__ContainerLabel"
})(["display:flex;"]);
var ImageHolder = _styledComponents["default"].div.withConfig({
  displayName: "insuranceProviderId__ImageHolder"
})(["display:block;margin-bottom:20px;"]);
var InsuranceProviderId = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2["default"])(InsuranceProviderId, _PureComponent);
  var _super = _createSuper(InsuranceProviderId);
  function InsuranceProviderId(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, InsuranceProviderId);
    _this = _super.call(this, props);
    _this.state = {
      mask: "H11111111",
      formState: 0,
      value: "",
      id: "",
      id_b: "",
      // backup
      id_confirm: "",
      // backup
      id_confirm_b: ""
    };
    _this.inputChange = _this.inputChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.restoreBack = _this.restoreBack.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onChange = _this.onChange.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }
  (0, _createClass2["default"])(InsuranceProviderId, [{
    key: "restoreBack",
    value: function restoreBack() {
      var _this2 = this;
      this.setState({
        id: this.state.id_b,
        id_confirm: this.state.id_confirm_b
      }, function () {
        return _this2.onChange();
      });
    }
  }, {
    key: "inputChange",
    value: function inputChange(_ref) {
      var _this$setState,
        _this3 = this;
      var name = _ref.name,
        value = _ref.value;
      // trimming white space
      // stripping out underscores
      var val = value.trim().replace(_constants.regexUnderscores, "");
      this.setState((_this$setState = {}, (0, _defineProperty2["default"])(_this$setState, name + "_b", value), (0, _defineProperty2["default"])(_this$setState, name, val), (0, _defineProperty2["default"])(_this$setState, "formState", 0), _this$setState), function () {
        return _this3.onChange();
      });
    }
  }, {
    key: "onChange",
    value: function onChange() {
      var _this$props$input = this.props.input,
        onChange = _this$props$input.onChange,
        onBlur = _this$props$input.onBlur;
      var _this$state = this.state,
        id = _this$state.id,
        id_confirm = _this$state.id_confirm;
      onBlur();
      if (id === id_confirm) {
        onChange(id);
      } else {
        onChange("");
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;
      var _this$state2 = this.state,
        message = _this$state2.message,
        formState = _this$state2.formState,
        mask = _this$state2.mask,
        id = _this$state2.id,
        id_confirm = _this$state2.id_confirm;
      var _this$props = this.props,
        inputStyle = _this$props.inputStyle,
        _this$props$input2 = _this$props.input,
        _onChange = _this$props$input2.onChange,
        _onBlur = _this$props$input2.onBlur,
        _this$props$meta = _this$props.meta,
        error = _this$props$meta.error,
        dirty = _this$props$meta.dirty,
        valid = _this$props$meta.valid,
        label = _this$props.label,
        labelStyle = _this$props.labelStyle,
        disabled = _this$props.disabled,
        t = _this$props.t;
      var humanaImgAlt = t('components.insuranceProviderId.idImage');
      var medicareLabel = t('components.insuranceProviderId.medicareId');
      var reenterLabel = t('components.insuranceProviderId.reenter');
      var notMemberLabel = t('components.insuranceProviderId.notMember');
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_formElements.InputLabel, {
        labelStyle: labelStyle,
        label: "".concat(label)
      }), /*#__PURE__*/_react["default"].createElement(ImageHolder, null, /*#__PURE__*/_react["default"].createElement("img", {
        style: {
          width: "100%",
          height: "auto"
        },
        src: "https://s3.amazonaws.com/assets.achievemint.com/study/humanaCard.gif",
        alt: humanaImgAlt
      })), /*#__PURE__*/_react["default"].createElement(List, {
        className: "insuranceProvider"
      }, /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement(ContainerLabel, {
        id: "t-medicare_yes",
        htmlFor: "medicare_yes"
      }, /*#__PURE__*/_react["default"].createElement(InputRadio, {
        id: "medicare_yes",
        onChange: function onChange(e) {
          return _this4.setState({
            formState: 0
          }, function () {
            return _this4.restoreBack();
          });
        },
        checked: formState === 0,
        type: "radio",
        disabled: disabled
      }), /*#__PURE__*/_react["default"].createElement(_horizontalLabel["default"], {
        label: medicareLabel
      })), /*#__PURE__*/_react["default"].createElement(_formElements.MaskedInput, {
        className: "insuranceprovider ".concat((0, _utils.constructFieldClassname)(this.props.meta)),
        mask: mask,
        name: "id",
        id: "insurance_id",
        inputStyle: inputStyle,
        labelStyle: labelStyle,
        value: this.state.id,
        onChange: function onChange(_ref2) {
          var value = _ref2.target.value;
          return _this4.inputChange({
            name: "id",
            value: value
          });
        },
        disabled: formState === 1 || formState === undefined || disabled,
        style: {
          margin: "5px 0 10px 20px",
          width: "90%"
        },
        onBlur: function onBlur() {
          return _onBlur(id === id_confirm ? id : "");
        }
      })), /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement(_formElements.InputLabel, {
        label: reenterLabel,
        labelStyle: "dark",
        style: {
          marginLeft: 20
        }
      }, /*#__PURE__*/_react["default"].createElement(_formElements.MaskedInput, {
        className: "insuranceprovider ".concat((0, _utils.constructFieldClassname)(this.props.meta)),
        mask: mask,
        id: "insurance_id_confirm",
        inputStyle: inputStyle,
        labelStyle: labelStyle,
        value: this.state.id_confirm,
        onChange: function onChange(_ref3) {
          var value = _ref3.target.value;
          return _this4.inputChange({
            name: "id_confirm",
            value: value
          });
        },
        onBlur: function onBlur() {
          return _onBlur(id === id_confirm ? id : "");
        },
        disabled: formState === 1 || formState === undefined || disabled,
        style: {
          margin: "5px 0 5px 20px",
          width: "90%"
        }
      })), error && /*#__PURE__*/_react["default"].createElement(_formElements.InputError, null, error), formState === 0 && dirty && !valid && /*#__PURE__*/_react["default"].createElement(_formElements.InputError, null, message)), /*#__PURE__*/_react["default"].createElement("li", {
        style: {
          marginTop: 20
        }
      }, /*#__PURE__*/_react["default"].createElement(ContainerLabel, {
        id: "t-medicare_no",
        htmlFor: "medicare_no"
      }, /*#__PURE__*/_react["default"].createElement(InputRadio, {
        id: "medicare_no",
        onChange: function onChange(e) {
          return _this4.setState({
            id: "",
            id_confirm: "",
            formState: 1
          }, function () {
            return _onChange('false');
          });
        },
        checked: formState === 1,
        type: "radio",
        disabled: disabled
      }), /*#__PURE__*/_react["default"].createElement(_horizontalLabel["default"], {
        label: notMemberLabel
      })))));
    }
  }]);
  return InsuranceProviderId;
}(_react.PureComponent);
var InsuranceProviderIdWithTranslation = (0, _reactI18next.withTranslation)(_LanguageContext.curiousPandaNamespace)(InsuranceProviderId);
InsuranceProviderIdWithTranslation.handlesErrorDisplay = true;
var _default = exports["default"] = InsuranceProviderIdWithTranslation;